namespace Portico.Services {
	import pme = Portico.Models.Enterprise;
	import pmg = Portico.Models.Gateway;
	import psga = apigateway.client;
	import psgm = apigateway.models;
	import psge = apigateway.enums;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface ISiteService {
		create(addresses?: number, contacts?: number, emailAddresses?: number, externalIds?: number, phoneNumbers?: number): angular.IPromise<pme.Site>;
		get(siteId: number): angular.IPromise<pme.Site>;
		getByPrescriberId(prescriberId: number): angular.IPromise<pme.Site[]>;
		save(site: pme.Site): angular.IPromise<pme.Site>;
		search(site: pme.Site): angular.IPromise<pme.Site[]>;
    }

    @Service('app', 'siteService')
	@Inject('$q', 'SiteV3Api')
    export class SiteService implements ISiteService {
        constructor(
            private $q: angular.IQService,
			private siteV3Api: psga.SiteV3Api
        ) { }

		create(addresses: number = 0, contacts: number = 0, emailAddresses: number = 0, externalIds: number = 0, phoneNumbers: number = 0): angular.IPromise<pme.Site> {
			const site = new pme.Site();

			for (let i = 0; i < addresses; i++) {
				site.addAddress();
			}

			for (let i = 0; i < contacts; i++) {
				site.addContact();
			}

			for (let i = 0; i < emailAddresses; i++) {
				site.addEmailAddress();
			}

			for (let i = 0; i < externalIds; i++) {
				site.addExternalId();
			}

			for (let i = 0; i < phoneNumbers; i++) {
				site.addPhoneNumber();
			}

			return this.$q.when(site);
		}

		get(siteId: number): angular.IPromise<pme.Site> {
			// TODO: wrap in an edge call
			return this.$q.when(this.siteV3Api.siteGetByTenantId(siteId, psge.RoleType.PrescriberSite).then((response) => {
				response.data.data.businessEndTime = <moment.Moment><unknown>response.data.data.businessEndTime?.toDate();
				response.data.data.businessStartTime = <moment.Moment><unknown>response.data.data.businessStartTime?.toDate();
				return new pme.Site(response.data.data);
			}));
		}

		getByPrescriberId(prescriberId: number): angular.IPromise<pme.Site[]> {
			// TODO: wrap in an edge call
			return this.$q.when(this.siteV3Api.sitesByPrescriberGetByTenantId1(prescriberId).then((response) => {
				const temp: pme.Site[] = [];

				for (let site of response.data.data) {
					site.businessEndTime = <moment.Moment><unknown>site.businessEndTime?.toDate();
					site.businessStartTime = <moment.Moment><unknown>site.businessStartTime?.toDate();
					temp.push(new pme.Site(site));
				}

				return temp;
			}));
		}

		save(site: pme.Site): angular.IPromise<pme.Site> {
			const request: psgm.SiteUpsearchModel = {
				siteId: _.toNumber(site.id),
				siteRoleType: psge.RoleType.PrescriberSite,
				description: _.get(site, 'description', ''),
				nickName: _.get(site, 'nickName', ''),
				businessStartTime: moment(_.get(site, 'businessStartTime', '')),
				businessEndTime: moment(_.get(site, 'businessEndTime', '')),
				stateTaxId: null,
				npi: null,
				siteNote: null,
				contacts: _.map(site.contacts, (v) => {
					return {
						contactId: v.id,
						contactType: _.toNumber(v.type),
						firstName: _.get(v, 'firstName', ''),
						lastName: _.get(v, 'lastName', ''),
						occupationDescription: _.get(v, 'occupationDescription', ''),
						addresses: _.map(v.addresses, (u) => {
							return {
								addressId: u.id,
								addressType: _.toNumber(u.type),
								addressOne: _.get(u, 'address1', ''),
								addressTwo: _.get(u, 'address2', ''),
								city: _.get(u, 'city', ''),
								state: _.get(u, 'state', ''),
								zip: _.get(u, 'zip', ''),
								country: _.get(u, 'country', '')
							};
						}),
						emailAddresses: _.map(v.emailAddresses, (u) => {
							return {
								emailAddressId: u.id,
								emailAddressType: _.toNumber(u.type),
								address: _.get(v, 'address', ''),
								language: _.get(v, 'language', '')
							};
						}),
						phoneNumbers: _.map(v.phoneNumbers, (u) => {
							return {
								phoneId: u.id,
								phoneType: _.toNumber(u.type),
								phonePurpose: _.toNumber(u.purpose),
								phoneNumber: _.get(v, 'number', ''),
								extension: _.get(v, 'extension', ''),
								contactDatePreferenceType: _.toNumber(u.contactDatePreferenceType),
								bestDaysToCall: _.get(v, 'bestDaysToCall', ''),
								contactTimePreferenceType: _.toNumber(u.contactTimePreferenceType),
								bestTimeToCall: _.get(v, 'bestTimeToCall', ''),
								language: _.get(v, 'language', ''),
								timeZone: _.get(v, 'timeZone', '')
							};
						}),
						webAddresses: _.map(v.webAddresses, (u) => {
							return {
								webAddressId: u.id,
								webAddressType: _.toNumber(u.type),
								url: _.get(v, 'url', '')
							};
						})
					};
				}),
				externalIds: _.map(site.externalIds, (v) => {
					return {
						id: v.id,
						externalIdType: _.toNumber(v.type),
						externalId: _.get(v, 'value', '')
					};
				}),
				globalIds: null,
				addresses: _.map(site.addresses, (v) => {
					return {
						addressId: v.id,
						addressType: _.toNumber(v.type),
						addressOne: _.get(v, 'address1', ''),
						addressTwo: _.get(v, 'address2', ''),
						city: _.get(v, 'city', ''),
						state: _.get(v, 'state', ''),
						zip: _.get(v, 'zip', ''),
						country: _.get(v, 'country', '')
					};
				}),
				phoneNumbers: _.map(site.phoneNumbers, (v) => {
					return {
						phoneId: v.id,
						phoneType: _.toNumber(v.type),
						phonePurpose: _.toNumber(v.purpose),
						phoneNumber: _.get(v, 'number', ''),
						extension: _.get(v, 'extension', ''),
						contactDatePreferenceType: _.toNumber(v.contactDatePreferenceType),
						bestDaysToCall: _.get(v, 'bestDaysToCall', ''),
						contactTimePreferenceType: _.toNumber(v.contactTimePreferenceType),
						bestTimeToCall: _.get(v, 'bestTimeToCall', ''),
						language: _.get(v, 'language', ''),
						timeZone: _.get(v, 'timeZone', '')
					};
				}),
				emailAddresses: _.map(site.emailAddresses, (v) => {
					return {
						emailAddressId: v.id,
						emailAddressType: _.toNumber(v.type),
						address: _.get(v, 'address', ''),
						language: _.get(v, 'language', '')
					};
				})
			};

			// TODO: wrap in an edge call
			return this.$q.when(this.siteV3Api.siteUpsearchByTenantId({
				canInsert: true,
				canUpdate: true,
				skipSearch: false,
				model: request
			}).then((response) => {
				return new pme.Site(response.data.data);
			}));
        }

		search(site: pme.Site): angular.IPromise<pme.Site[]> {
			const request: DeepPartial<psgm.SiteSearchRequestModel> = {
				maxRecordCount: 20,
				description: _.get(site, 'description', ''),
				npi: _.get(_.find(_.get(site, 'externalIds', []), { type: pmg.ExternalIdType.NPINUMBER } as any), 'value', ''), // 6: NPINUMBER,
				addressOne: _.get(site, 'addresses[0].address1', ''),
				city: _.get(site, 'addresses[0].city', ''),
				state: _.get(site, 'addresses[0].state', ''),
				zip: _.get(site, 'addresses[0].zip', ''),
				roleType: psge.RoleType.PrescriberSite,
				externalIdType: null,
				externalId: ''
			};

			// TODO: wrap in an edge call
			return this.$q.when(this.siteV3Api.siteSearchByTenantId(request).then((response) => {
                const temp: pme.Site[] = [];

				for (let site of response.data.data.sites) {
					site.businessEndTime = <moment.Moment><unknown>site.businessEndTime?.toDate();
					site.businessStartTime = <moment.Moment><unknown>site.businessStartTime?.toDate();
                    temp.push(new pme.Site(site));
                }

                return temp;
            }));
        }
    }
}